// Reading the runtime's research block: the answer (Markdown-lite) and its citations, or a
// "Couldn't research this" state when the label says research was not available.
import type { CardBlock } from "@shared/core";

const NOT_AVAILABLE = /not available/i;
const COULDNT = /^\s*couldn[’']t research this\s*[:.,-]?\s*/i;

export interface ResearchState {
  available: boolean;
  /** The answer text when available. */
  answer: string;
  /** Why research could not run, in the server's words (without the "Couldn't research this"). */
  reason: string | null;
}

export function researchState(block: Pick<CardBlock, "label" | "value" | "text">): ResearchState {
  const body = (block.value ?? block.text ?? "").trim();
  const unavailable = NOT_AVAILABLE.test(block.label ?? "") || (!!body && COULDNT.test(body));
  if (!unavailable) return { available: true, answer: body, reason: null };
  const reason = body.replace(COULDNT, "").trim();
  return {
    available: false,
    answer: "",
    reason: reason ? reason[0]!.toUpperCase() + reason.slice(1) : null,
  };
}

/** Host shown next to a citation ("vendor.example"), or the raw text when it is not a URL. */
export function citationHost(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}
